import { useCallback, useEffect, useState } from "react";

// 260803 브라우저별 Fullscreen API 차이를 한곳에서 처리한다.
export const getFullscreenElement = () => document.fullscreenElement || document.webkitFullscreenElement || null;

export const requestPageFullscreen = () => {
    const element = document.documentElement;
    const request = element.requestFullscreen || element.webkitRequestFullscreen;
    return request ? Promise.resolve(request.call(element)).catch(() => false) : Promise.resolve(false);
};

export const exitPageFullscreen = () => {
    if (!getFullscreenElement()) return Promise.resolve(true);
    const exit = document.exitFullscreen || document.webkitExitFullscreen;
    return exit ? Promise.resolve(exit.call(document)).catch(() => false) : Promise.resolve(false);
};

// 260803 전체화면 상태와 ON/OFF 버튼 표시를 ESC 해제까지 동기화한다.
export const usePageFullscreen = (requestOnMount = false) => {
    const [isFullscreen, setIsFullscreen] = useState(() => !!getFullscreenElement());

    useEffect(() => {
        const update = () => {
            setIsFullscreen(!!getFullscreenElement());
            // 260804 전체화면 레이아웃이 확정된 뒤 기존 화면 크기 계산 로직이 다시 실행되도록 알린다.
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
            });
        };
        document.addEventListener("fullscreenchange", update);
        document.addEventListener("webkitfullscreenchange", update);
        if (requestOnMount) requestPageFullscreen();
        return () => {
            document.removeEventListener("fullscreenchange", update);
            document.removeEventListener("webkitfullscreenchange", update);
        };
    }, [requestOnMount]);

    const toggleFullscreen = useCallback(() => {
        return getFullscreenElement() ? exitPageFullscreen() : requestPageFullscreen();
    }, []);

    return { isFullscreen, toggleFullscreen };
};
